import { useState } from 'react'
import { api } from 'lib/axios'

const OcrQueueProcessor = async payload => {
  const response = await api.post(
    '/Api/V8/custom/customer/batch-ocr-process-queue',
    payload
  )
  return response
}

export const useOcrQueueProcessor = () => {
  const [isOcrQueueProcessorDataLoading, setIsOcrQueueProcessorDataLoading] =
    useState(false)

  const handleOcrQueueProcessor = async payload => {
    setIsOcrQueueProcessorDataLoading(true)
    try {
      const response = await OcrQueueProcessor(payload)
      if (response) {
        return response
      } else {
        console.error('Ocr Queue Processor failed:', response)
        return null
      }
    } catch (error) {
      console.error('Ocr Queue Processor failed:', error)
    } finally {
      setIsOcrQueueProcessorDataLoading(false)
    }
  }

  return {
    isOcrQueueProcessorDataLoading,
    handleOcrQueueProcessor
  }
}
